import React from 'react'

function Footer() {
  return (
    <footer>
      <p>
        Bait and Switch 2025
      </p>
    </footer>
  )
}

export default Footer